import { default as getByIdConfiguration } from './getById';
import { default as loadMoreConfiguration } from './loadMore';
import { default as rateContentConfiguration } from './rateContent';

export const configurations = [
  getByIdConfiguration,
  loadMoreConfiguration,
  rateContentConfiguration
]


// WEBPACK FOOTER //
// ./src/state/modules/content/configurations/index.js